import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserBoardPage } from './user-board';
import { OauthService } from '../../shared/services/oauth.service';
import { CoreModule } from '../../core/core.module';
import { LocalStorageService } from '../../shared/services/localStorage.service';

@NgModule({
  declarations: [
    UserBoardPage
  ],
  imports: [
    IonicPageModule.forChild(UserBoardPage),
    CoreModule
  ],
  exports: [
    UserBoardPage
  ],
  entryComponents: [
    UserBoardPage
  ],
  providers: [
    OauthService,
    LocalStorageService,
  ]
})
export class UserBoardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-board/user-board.module.ts